module.exports = __webpack_public_path__ + "img/asset_manager.214d86c1.png";